export const KANBAN_CARD_EMPTY_DISPLAY = "-";

export function formatKanbanCardFieldValue(value: string | null | undefined): string {
    if (value === null || value === undefined) {
        return KANBAN_CARD_EMPTY_DISPLAY;
    }
    const trimmed = value.trim();
    if (trimmed === "" || trimmed === "?") {
        return KANBAN_CARD_EMPTY_DISPLAY;
    }
    return value;
}
